import React, { Component } from 'react'
import Img from 'gatsby-image'

class Collapse extends Component{
	constructor(props){
		super(props)

		this.state = {
			isOpen: false
		}
	}

	handleChange = () => {
		this.setState(state => ({isOpen: !state.isOpen}))
	}

	handleKeyDown = (event) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault()
			this.handleChange()
		}
	}

	render(){
		const {attrs, images} = this.props
		
		// Validation des props
		if (!attrs || !attrs.title || !attrs.collapseContent) {
			return (
				<div role="alert" aria-live="polite" className="collapse-error">
					Configuration de l'accordéon invalide
				</div>
			)
		}

		const image = attrs.mediaId && images && images.find(({wordpress_id}) => wordpress_id === attrs.mediaId)
		const imageSharpSizes = (image && image.localFile && image.localFile.childImageSharp && image.localFile.childImageSharp.sizes) || false
		const altText = attrs.altText || attrs.title || 'Image de l\'accordéon'
		
		return(
			<div 
				className={`block-collapse${this.state.isOpen ? ' block-collapse-opened' : ''}`}
				role="region"
				aria-label="Section accordéon"
			>
				<button 
					onClick={this.handleChange} 
					onKeyDown={this.handleKeyDown}
					className="block-collapse-button"
					aria-expanded={this.state.isOpen}
					aria-controls={`collapse-content-${attrs.mediaId || 'default'}`}
					aria-label={`${this.state.isOpen ? 'Réduire' : 'Développer'} ${attrs.title}`}
				>
					<div className="block-collapse-title" dangerouslySetInnerHTML={{__html: attrs.title}} />
				</button>
				<div 
					id={`collapse-content-${attrs.mediaId || 'default'}`}
					className="block-collapse-content"
					role="region"
					aria-label="Contenu de l'accordéon"
					aria-expanded={this.state.isOpen}
				>
					<div dangerouslySetInnerHTML={{__html: attrs.collapseContent}} />
					{imageSharpSizes && (
						<Img 
							sizes={imageSharpSizes} 
							alt={altText}
							role="img"
							aria-hidden="false"
						/>
					)}
				</div>
			</div>
		)
	}
}

export default Collapse
